import React, { useEffect, useState } from "react";
// import { getQueueData } from "../../../helpers/api";
import { useAccount } from "wagmi";
import man from "../../../images/man.png";
import man1 from "../../../images/office-man.png";
import { currentIndexGlobalQ } from "../../../services/getWeb3";
import medal from "../../../images/medal.png";
import down from "../../../images/chevron-double-down.png";
import axios from "axios";
import { URLApi } from "../../../services/api_function";

function Queue() {
  const [queueData, setQueueData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(1);
  const [selectedQid, setSelectedQid] = useState("");
  const [uniqueQids, setUniqueQids] = useState([]);
  const { address } = useAccount();
  const [currentindex, setCurrentIndex] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [myPosition, setMyPosition] = useState(0);
  const [nextTurn, setNextTurn] = useState(null);
  const [keyofNextTurn, setKeyofNextTurn] = useState(null);

  // console.log(nextTurn, "next turn");

  const getQueue = async () => {
    console.log(address,"this is the address")
    try {
        setLoading(true);
        const response = await axios.get(`${URLApi}/getQueueData`);
        const data = response?.data?.queueData || [];
    
        setQueueData(data);
    
        const qids = [...new Set(data.map((item) => item.qid))];
        setUniqueQids(qids);
        if (qids.length > 0) setSelectedQid(qids[0]); // default to first qid
    } catch (error) {
      console.error("Error fetching queue data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSlotChange = (e) => {
    setSelectedValue(Number(e.target.value));
  };

  useEffect(() => {
    getQueue();
  }, []);

  const indexQueueData = async () => {
    const indexedData = await currentIndexGlobalQ(selectedValue, selectedQid);
    setCurrentIndex(Number(indexedData));
  };

  // console.log(currentindex, "current index");

  useEffect(() => {
    indexQueueData();
  }, [address, selectedValue, selectedQid]);

  const filteredData = queueData.filter(
    (item) =>
      item.package_id === Number(selectedValue) &&
      item.qid === Number(selectedQid)
  );

  useEffect(() => {
    setTotalUsers(filteredData?.length);
  }, [filteredData]);

  const getUserQueueAfterCurrent = (
    queueData,
    userAddress,
    packageId,
    currentPosition
  ) => {
    const filteredQueue = queueData.filter(
      (item) =>
        item.package_id === packageId && item.qid === Number(selectedQid)
    );
    const arr = [];

    filteredData.forEach((item, index) => {
      if (item.user_address.toLowerCase() === address.toLowerCase()) {
        arr.push(index);
      }
    });

    const sortedQueue = filteredQueue.sort((a, b) => a.timestamp - b.timestamp);

    const userIndex = sortedQueue.findIndex(
      (item) => item.user_address.toLowerCase() === userAddress.toLowerCase()
    );

    const currentIndex = currentPosition - 1;
    let newTurn = [];
    console.log(arr, "::::::::arr", currentIndex);
    arr.forEach((item, index) => {
      newTurn.push({ [item]: item - currentIndex });
    });
    console.log(newTurn, "::::::new turn");
    setNextTurn(newTurn);

    if (userIndex === -1) return -1;
    if (userIndex <= currentIndex) return 0;

    return userIndex - currentIndex;
  };

  useEffect(() => {
    const position = getUserQueueAfterCurrent(
      queueData,
      address,
      selectedValue,
      currentindex
    );
    setMyPosition(position);
  }, [queueData, address, selectedValue, selectedQid, currentindex]);

  return (
    <div className="row justify-content-center timeline-2">
      <div className="col-xxl-12">
        <div className="card custom-card">
          <div className="card-header justify-content-between d-flex align-items-center border-bottom">
          <div
  className="card-title text-white"
  style={{ fontSize: "22px", fontWeight: "600" }}
>
  {selectedValue >= 1 && selectedValue <= 4
    ? "Queue Ranking in 100 Users"
    : selectedValue >= 5 && selectedValue <= 7
    ? "Queue Ranking in 50 Users"
    : selectedValue >= 8 && selectedValue <= 10
    ? "Queue Ranking in 25 Users"
    : "Queue Ranking in 100 Users"}
</div>
            <div className="d-flex gap-2">
              <select
                className="form-select text-white bg-transparent"
                style={{ zIndex: 10, width: "150px" }}
                value={selectedValue}
                onChange={handleSlotChange}
              >
                <option value="" disabled className="text-info bg-dark">
                  Select a Slot
                </option>
                {[...Array(10)].map((_, i) => (
                  <option
                    key={i + 1}
                    value={i + 1}
                    className="text-white bg-dark"
                  >
                    Package {i + 1}
                  </option>
                ))}
              </select>

              <select
                className="form-select text-white bg-transparent"
                style={{ zIndex: 10, width: "150px" }}
                value={selectedQid}
                onChange={(e) => setSelectedQid(Number(e.target.value))}
              >
                <option value="" disabled className="text-info bg-dark">
                  Select a Queue
                </option>
                {uniqueQids.map((qid) => (
                  <option key={qid} value={qid} className="text-white bg-dark">
                    Queue {qid}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <ul className="notification container px-3">
            {filteredData.length === 0 && !loading && (
              <div className="text-center text-muted py-4">
                No data found for selected package.
              </div>
            )}

            {filteredData.map((item, index) => (
              <li key={item._id}>
                <div className="row">
                  {index % 2 === 0 ? (
                    <>
                      <div className="col-xl-6 second-col">
                        <div
                          className="notification-time d-flex align-items-center gap-2 justify-content-end"
                          style={{ paddingRight: "27px" }}
                        >
                          <span className="date">
                            {new Date(item.createdAt).toLocaleDateString()}
                          </span>
                          <span className="time">
                            {new Date(item.createdAt).toLocaleTimeString()}
                          </span>
                        </div>

                        <div className="notification-icon">
                          {currentindex == index + 1 ? (
                            <img src={medal} alt="" style={{ width: "30px" }} />
                          ) : (
                            <img src={down} alt="" style={{ width: "15px" }} />
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 first-col">
                        <div
                          className={`notification-body border border-primary border-opacity-50 ${
                            address?.toLowerCase() ===
                            item?.user_address?.toLowerCase()
                              ? "bg-primary-transparent bg-opacity-10"
                              : currentindex === index + 1
                              ? "bg-success border-danger"
                              : "bg-warning-transparent border-warning"
                          }`}
                        >
                          <div className="d-flex align-items-start gap-3 flex-wrap">
                            {address?.toLowerCase() === item?.user_address ? (
                              <div>
                                <span className="avatar avatar-lg online">
                                  <img src={man} alt="" />
                                </span>
                              </div>
                            ) : (
                              <div>
                                <span className="avatar avatar-lg">
                                  <img src={man1} alt="" />
                                </span>
                              </div>
                            )}
                            <div className="flex-fill w-50">
                              <h5
                                className={`"mb-1 fs-15 fw-medium  ${
                                  currentindex == index + 1
                                    ? "text-secondary"
                                    : "text-dark"
                                }`}
                              >
                                User ID
                              </h5>
                              <p className="mb-0 text-info">
                                {item.user_address.slice(0, 8)}...
                                {item.user_address.slice(-6)}
                              </p>
                            </div>
                            <div className="d-flex flex-column align-items-end">
                              <span className="badge bg-primary-transparent mb-1">
                                Queue ID: {item.qid}
                              </span>
                              <span className="badge bg-primary-transparent">
                                Package #{item.package_id} - Place {item.place}
                              </span>
                              {address?.toLowerCase() ===
                              item?.user_address?.toLowerCase()
                                ? (() => {
                                    const match = nextTurn.find(
                                      (obj) =>
                                        Number(Object.keys(obj)[0]) === index
                                    );
                                    const value = match
                                      ? Object.values(match)[0]
                                      : null;

                                    return value !== null &&
                                      typeof value !== "object" ? (
                                      <span className="badge bg-primary-transparent">
                                        Rank : {value}
                                      </span>
                                    ) : null;
                                  })()
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-xl-6 first-col">
                        <div
                          className={`notification-body border border-primary border-opacity-50 ${
                            address?.toLowerCase() ===
                            item?.user_address?.toLowerCase()
                              ? "bg-primary-transparent bg-opacity-10"
                              : currentindex === index + 1
                              ? "bg-success border-danger"
                              : "bg-warning-transparent border-warning"
                          }`}
                        >
                          <div className="d-flex align-items-start gap-3 flex-wrap">
                            {address?.toLowerCase() === item?.user_address ? (
                              <div>
                                <span className="avatar avatar-lg online">
                                  <img src={man} alt="" />
                                </span>
                              </div>
                            ) : (
                              <div>
                                <span className="avatar avatar-lg">
                                  <img src={man1} alt="" />
                                </span>
                              </div>
                            )}
                            <div className="flex-fill w-50">
                              <h5
                                className={`"mb-1 fs-15 fw-medium  ${
                                  currentindex === index + 1
                                    ? "text-secondary"
                                    : "text-dark"
                                }`}
                              >
                                User ID
                              </h5>
                              <p className="mb-0 text-info">
                                {item.user_address.slice(0, 8)}...
                                {item.user_address.slice(-6)}
                              </p>
                            </div>
                            <div className="d-flex flex-column align-items-end">
                              <span className="badge bg-primary-transparent mb-1">
                                Queue ID: {item.qid}
                              </span>
                              <span className="badge bg-primary-transparent mb-1">
                                Package #{item.package_id} - Place {item.place}
                              </span>
                              {address?.toLowerCase() ===
                              item?.user_address?.toLowerCase()
                                ? (() => {
                                    const match = nextTurn.find(
                                      (obj) =>
                                        Number(Object.keys(obj)[0]) === index
                                    );
                                    const value = match
                                      ? Object.values(match)[0]
                                      : null;

                                    return value !== null &&
                                      typeof value !== "object" ? (
                                      <span className="badge bg-primary-transparent">
                                        Rank : {value}
                                      </span>
                                    ) : null;
                                  })()
                                : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 second-col">
                        <div className="notification-time d-flex align-items-center gap-2">
                          <span className="date">
                            {new Date(item.createdAt).toLocaleDateString()}
                          </span>
                          <span className="time">
                            {new Date(item.createdAt).toLocaleTimeString()}
                          </span>
                        </div>

                        <div className="notification-icon">
                          {currentindex == index + 1 ? (
                            <img src={medal} alt="" style={{ width: "30px" }} />
                          ) : (
                            <img src={down} alt="" style={{ width: "15px" }} />
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </li>
            ))}
          </ul>

          {loading && (
            <div className="text-center mb-4">
              <button
                className="btn btn-success-light btn-loader mx-auto"
                disabled
              >
                <span className="me-2">Loading</span>
                <span className="loading">
                  <i className="ri-loader-4-line fs-16"></i>
                </span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Queue;
